import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Row,
    Table,
    Tag,
    Input,
} from "antd";

import {
    ArrowLeftOutlined,
    EditOutlined,
    PrinterOutlined,
} from "@ant-design/icons";

import Layout from '../../Layout'
import { useNavigate, Link } from "react-router-dom";

export default function OrderDetailPage() {
  const { t } = useTranslation();

    const navigate = useNavigate();
    const columns = [
        { title: t('order.col_code'), dataIndex: "code" },
        { title: t('order.col_name'), dataIndex: "name" },
        { title: t('order.col_image'), dataIndex: "image" },
        { title: t('order.col_price'), dataIndex: "price" },
        { title: t('order.col_qty'), dataIndex: "qty" },
        { title: t('order.col_note'), dataIndex: "note" },
        { title: t('order.col_weight'), dataIndex: "weight" },
        {
            title: t('order.col_total'),
            render: (r: any) => (
                <span className="text-red-500 font-semibold">
                    {r.price * r.qty}
                </span>
            ),
        },
    ];

    const data = [
        {
            key: 1,
            code: "",
            name: "Sản phẩm 12",
            image: "",
            price: 22,
            qty: 1,
            note: "",
            weight: 100,
        },
    ];

    return (
        <Layout>
            <Helmet>
                <title>{t('page.order_details')} | Khothi</title>
            </Helmet>
            <div className="space-y-4">

                {/* Breadcrumb */}
                <Breadcrumb
                    items={[
                        { title: <Link to="/">{t('sidebar.overview')}</Link> },
                        { title: <Link to="/appointments">{t('sidebar.orders')}</Link> },
                        { title: t('page.order_details') },
                    ]}
                />

                {/* Header */}
                <div className="flex flex-wrap gap-2 items-center">

                    <Button icon={<ArrowLeftOutlined />}>
                        {t('order.title')}
                    </Button>

                    <Button onClick={() => navigate("/appointment/create")} icon={<EditOutlined />}>
                        {t('order.edit')}
                    </Button>

                    <Button icon={<PrinterOutlined />}>
                        {t('order.print')}
                    </Button>

                    <Button type="primary">
                        {t('order.delivery_success')}
                    </Button>

                    <Button danger>
                        {t('order.cancel')}
                    </Button>

                    <Button>
                        {t('order.shipping')}
                    </Button>

                </div>

                {/* Order Info */}
                <Row gutter={16} align="stretch">
                    {/* Đặt hàng từ */}
                    <Col xs={24} md={8} className="flex">
                        <Card className="flex-1" title={t('order.order_from')}>
                            <p className="text-000000e0"><b>{t('order.warehouse')}:</b> Kho 1</p>
                            <p className="text-000000e0"><b>{t('order.address')}:</b> tphcm, PHƯỜNG 4, QUẬN 6</p>
                            <p className="text-000000e0"><b>{t('order.phone')}:</b> 0987654321</p>
                            <p className="text-000000e0"><b>{t('order.email')}:</b> kho@gmail.com</p>
                        </Card>
                    </Col>

                    {/* Lịch hẹn tới */}
                    <Col xs={24} md={8} className="flex">
                        <Card className="flex-1" title={t('order.order_to')}>
                            <p className="text-[#3e91ab] font-semibold">
                                Nguyễn văn A
                            </p>
                            <p className="text-000000e0">{t('order.address')}: Hà Nội</p>
                            <p className="text-000000e0">SĐT: 098764321</p>
                            <p className="text-000000e0">{t('order.email')}:</p>
                            <p className="text-000000e0">{t('order.page')}:</p>
                        </Card>
                    </Col>

                    {/* Thông tin chính */}
                    <Col xs={24} md={8} className="flex">
                        <Card className="flex-1" title={t('order.main_info')}>
                            <p className="text-000000e0">{t('order.col_order_code')}: <b>1773022330601</b></p>
                            <p className="text-000000e0">{t('order.contract_code')}: sdsd</p>
                            <p className="text-000000e0">{t('order.shipping_method')}: default</p>
                            <p className="text-000000e0">{t('order.shipping_code')}:</p>
                            <p className="text-000000e0">{t('order.creator')}:</p>
                        </Card>
                    </Col>
                </Row>
                {/* Product Table */}
                <Card>
                    <Table
                        scroll={{ x: "max-content" }}
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        className="custom-ant-table"
                    />

                    {/* Notes + Total */}
                    <Row gutter={24} className="mt-6">
                        <Col xs={24} md={12}>

                            <div className="space-y-4">

                                <div>
                                    <div className="text-sm mb-1 text-000000e0">
                                        {t('order.internal_note')}
                                    </div>
                                    <Input />
                                </div>

                                <div>
                                    <div className="text-sm mb-1 text-000000e0">
                                        {t('order.shipping_note')}
                                    </div>
                                    <Input />
                                </div>

                            </div>

                        </Col>

                        <Col xs={24} md={12}>

                            <div className="space-y-2 text-sm text-000000e0 md:mt-0 mt-4">

                                <div className="flex justify-between">
                                    <span>{t('order.total_amount')}</span>
                                    <span>22</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>{t('order.col_shipping_fee')}</span>
                                    <span>0</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>{t('order.shipping_fee_customer')}</span>
                                    <span>0</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>{t('order.discount')}</span>
                                    <span>0</span>
                                </div>

                                <div className="flex justify-between">
                                    <span>{t('order.paid')}</span>
                                    <span>0</span>
                                </div>

                                <div className="flex justify-between font-semibold">
                                    <span>Cod</span>
                                    <span>22</span>
                                </div>

                            </div>

                        </Col>
                    </Row>

                </Card>

                {/* History */}
                <Card title={t('order.status_update')}>

                    <Table
                        className="custom-ant-table"
                        scroll={{ x: "max-content" }}
                        pagination={{ pageSize: 5 }}
                        columns={[
                            { title: t('order.col_name'), dataIndex: "name" },
                            { title: t('order.col_info'), dataIndex: "info" },
                            { title: t('order.col_date'), dataIndex: "date" },
                            { title: t('order.col_status'), dataIndex: "status" },
                        ]}
                        dataSource={[
                            {
                                key: 1,
                                name: "Trà My Nguyễn",
                                info: t('order.added_new_order'),
                                date: "09-03-26 09:12",
                                status: 1,
                            },
                        ]}
                    />

                </Card>

            </div>
        </Layout>
    );
}